import { useState, useEffect } from 'react';

/** Соответствуют брейкпоинтам Ant Design Grid v5: md=768, lg=992 */
const Q_MD = '(min-width: 768px)';
const Q_LG = '(min-width: 992px)';

function readScreens() {
  if (typeof window === 'undefined') {
    return { md: false, lg: false };
  }
  return {
    md: window.matchMedia(Q_MD).matches,
    lg: window.matchMedia(Q_LG).matches,
  };
}

/**
 * Замена `Grid.useBreakpoint` без импорта `antd/Grid` — `md`/`lg` для сеток и `isMobile = !md`.
 * @returns {{ md: boolean, lg: boolean }}
 */
export function useBreakpointScreens() {
  const [screens, setScreens] = useState(() => readScreens());

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mqMd = window.matchMedia(Q_MD);
    const mqLg = window.matchMedia(Q_LG);
    const onChange = () => setScreens(readScreens());
    mqMd.addEventListener('change', onChange);
    mqLg.addEventListener('change', onChange);
    onChange();
    return () => {
      mqMd.removeEventListener('change', onChange);
      mqLg.removeEventListener('change', onChange);
    };
  }, []);

  return screens;
}
